import { useMemo, type SyntheticEvent, type CSSProperties } from 'react';
import { unionContexts } from 'r/utils';
import icon1 from './icons/1.png';
import icon2 from './icons/2.png';
import icon3 from './icons/3.png';
import icon4 from './icons/4.png';
import icon5 from './icons/5.png';
import icon6 from './icons/6.png';
import icon7 from './icons/7.png';
import icon8 from './icons/8.png';
import icon9 from './icons/9.png';
import icon10 from './icons/10.png';

const icons = [
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  icon7,
  icon8,
  icon9,
  icon10,
];

let styleInjected = false;

function injectGlobalStyle() {
  if (styleInjected || typeof document === 'undefined') return;
  styleInjected = true;
  const style = document.createElement('style');
  style.textContent = `
    .avatar-img {
      border-radius: 50%;
    }
    @media (max-width: 767px) {
      .avatar-img {
        width: var(--avatar-size-mobile) !important;
        height: var(--avatar-size-mobile) !important;
      }
    }
  `;
  document.head.appendChild(style);
}

injectGlobalStyle();

export default unionContexts(Avatar);

function Avatar({
  size,
  user,
}: {
  size: [number, number] | number;
  user: null | { id: string; avatar: null | string };
}) {
  const [sizeDesktop, sizeMobile] = Array.isArray(size) ? size : [size, size];
  const avatarSrc = useMemo(
    () => user && getAvatarSrc(user),
    [user?.id, user?.avatar],
  );

  const style = {
    '--avatar-size-desktop': `${sizeDesktop}px`,
    '--avatar-size-mobile': `${sizeMobile}px`,
    width: sizeDesktop,
    height: sizeDesktop,
    visibility: user ? undefined : 'hidden',
  } as CSSProperties;

  return (
    <img
      className="avatar-img"
      style={style}
      key={avatarSrc}
      onError={(e) => user && onImageError(e, user)}
      src={avatarSrc || undefined}
      alt=""
    />
  );
}

function getRandomAvatar(id: string) {
  const idLowerCased = id.toLowerCase();
  const idx = [...idLowerCased].reduce(
    (acc, c) => acc + Number(c.codePointAt(0)),
    0,
  );
  return icons[idx % 10];
}

function getAvatarSrc({ avatar, id }: { avatar: string | null; id: string }) {
  if (avatar?.startsWith('https://pbs.twimg.com')) {
    return avatar.replace('normal', 'bigger');
  }
  return (
    !avatar ? getRandomAvatar(id)
    : avatar.startsWith('http') ? avatar
    : `${import.meta.env.VITE_BACKEND_URL_BASE}/${avatar}`
  );
}

function onImageError(
  e: SyntheticEvent<HTMLImageElement>,
  { id }: { id: string },
) {
  e.currentTarget.src = getRandomAvatar(id);
}
